import {
  BatchListBasic,
  GetListsByUserRequest,
} from '@cbinsights/listservice/listservice';
import { request } from 'client/modules/common/utils/request';

export const getListsByUser = (
  req: Partial<GetListsByUserRequest>
): Promise<BatchListBasic> =>
  request({
    url: '/service/listservice/GetListsByUser',
    body: req,
  }).then((r) => r.body);
